export const retryRequest = async <T>(fn: () => Promise<T>, retries = 1, err = null): Promise<T> => {
  if (!retries) {
    return Promise.reject(err);
  }
  return await fn().catch((err) => {
    return retryRequest(fn, retries - 1, err);
  });
};
